<div>
  <div class="container">
    <span class="gap"></span>

    <div class="header">
      <h1>Past Events</h1>
      <p class="subtitle">Explore our archive of museum events and activities</p>
    </div>

    <div class="filter-bar">
      <label for="yearFilter">Filter by Year:</label>
      <select id="yearFilter" [(ngModel)]="selectedYear" (change)="filterByYear(selectedYear)" class="year-select">
        <option value="all">All Years</option>
        <option *ngFor="let year of years" [value]="year">{{year}}</option>
      </select>
    </div>

    <div *ngIf="loading" class="loading">
      <p>Loading past events...</p>
    </div>

    <div *ngIf="!loading && filteredEvents.length === 0" class="no-events">
      <p>No past events found.</p>
    </div>

    <div class="events-grid" *ngIf="!loading && filteredEvents.length > 0">
      <mat-card *ngFor="let event of filteredEvents" class="event-card">
        <div class="card-image" [style.background-image]="'url(' + event.fields.images[0]?.fields?.file?.url + ')'">
          <div class="image-overlay"></div>
        </div>
        <mat-card-header>
          <mat-chip class="date-chip">
            <ng-container *ngIf="event.fields.dateTime; else pastChipDateOnly">
              {{ event.fields.dateTime | date:'MMM d, y' }}
            </ng-container>
            <ng-template #pastChipDateOnly>
              {{ event.fields.date | date:'mediumDate' }}
            </ng-template>
          </mat-chip>
        </mat-card-header>
        <mat-card-content>
          <h2 [innerHTML]="event.fields.title | mdToHtml"></h2>
          <p class="description" [innerHTML]="event.fields.shortDescription | mdToHtml"></p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-stroked-button color="basic" [routerLink]="['/events', event.fields.url]">
            View Details
          </button>
          <button mat-raised-button color="primary" [routerLink]="['/gallery', event.fields.url]"
            *ngIf="event.fields.photos?.length">
            <mat-icon>photo_library</mat-icon>
            View Photos
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <span class="gap"></span>
  </div>
</div>